// extracted by mini-css-extract-plugin
export default {"tools":"Tools_tools__2Z09s","tool":"Tools_tool__kpqZb","toolsTitle":"Tools_toolsTitle__E+eF-"};